<template>
    <fieldset :disabled="isDisable">
        <div id="address">
            <div v-if="addresses && addresses.length">
                <div v-for="(address, index) in addresses" :key="address.id" class="row mb-3 pb-3 border-bottom">
                    <div class="col-md-9">
                        <div class="row mb-1">
                            <div class="col-4 col-md-3 text-muted">{{ $t('Address') }} {{ index + 1 }}</div>
                            <div class="col-8 col-md-9"><strong>{{ titleLabel(address.name) }}</strong></div>
                        </div>
                        <div class="row mb-1" v-if="address.line_1">
                            <div class="col-4 col-md-3 text-muted">{{ $t('Line 1') }}</div>
                            <div class="col-8 col-md-9">{{ address.line_1 }}</div>
                        </div>
                        <div class="row mb-1" v-if="address.line_2">
                            <div class="col-4 col-md-3 text-muted">{{ $t('Line 2') }}</div>
                            <div class="col-8 col-md-9">{{ address.line_2 }}</div>
                        </div>
                        <div class="row mb-1" v-if="address.line_3">
                            <div class="col-4 col-md-3 text-muted">{{ $t('Line 3') }}</div>
                            <div class="col-8 col-md-9">{{ address.line_3 }}</div>
                        </div>
                        <div class="row mb-1" v-if="!address.line_1 && !address.line_2 && !address.line_3 && address.details">
                            <div class="col-4 col-md-3 text-muted">{{ $t('Address') }}</div>
                            <div class="col-8 col-md-9">{{ address.details }}</div>
                        </div>
                        <div class="row mb-1" v-if="address.city">
                            <div class="col-4 col-md-3 text-muted">{{ $t('City') }}</div>
                            <div class="col-8 col-md-9">{{ address.city }}</div>
                        </div>
                        <div class="row mb-1" v-if="address.area && address.state">
                            <div class="col-4 col-md-3 text-muted">{{ $t('State') }}</div>
                            <div class="col-8 col-md-9">{{ address.state.state }}</div>
                        </div>
                        <div class="row mb-1" v-if="address.country">
                            <div class="col-4 col-md-3 text-muted">{{ $t('country') }}</div>
                            <div class="col-8 col-md-9">{{ address.country }}</div>
                        </div>
                        <div class="row mb-1" v-if="address.zip_code">
                            <div class="col-4 col-md-3 text-muted">{{ $t('Pin Code') }}</div>
                            <div class="col-8 col-md-9">{{ address.zip_code }}</div>
                        </div>
                    </div>
                    <div class="col-md-3" v-if="!isDisable">
                        <div class="d-flex justify-content-end">
                            <default-action :key="`default`" :actions="actions" :row-data="address"
                                :unique-key="address.id" @action="triggerAction" />
                        </div>
                    </div>
                </div>
            </div>
            <p v-else class="text-muted mb-2">{{ $t('not_added_yet') }}</p>

            <div v-if="!isDisable" class="mt-2">
                <a class="btn btn-primary text-white cursor-pointer" @click="addAddressModal">
                    {{ $t('add') }} {{ $t('address') }}
                </a>
                <app-address-modal v-if="isModalActive" v-model="isModalActive" :user-id="props[0]"
                    :selectedUrl="url" :user-type="userType" @close="isModalActive = false" @reload="getAddress" />
                <app-confirmation-modal v-if="confirmationModalActive" :firstButtonName="$t('yes')"
                    icon="trash-2" modal-class="warning" modal-id="app-confirmation-modal"
                    @cancelled="cancelled" @confirmed="deleteAddress" @reload="getAddress" />
            </div>
        </div>
    </fieldset>
</template>

<script>
import HelperMixin from "../../../../../common/Mixin/Global/HelperMixin";
import DefaultAction from "../../../../../core/components/datatable/DefaultAction";
import AddressModal from "./AddressCreateEditModal";
import { ADDRESS, CUSTOMER_ADDRESS } from "../../../../Config/ApiUrl-CPB";
import { axiosDelete, axiosGet } from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "Address",
    components: {
        DefaultAction,
        AddressModal
    },
    props: {
        props: {},
    },
    mixins: [HelperMixin],
    data() {
        return {
            isModalActive: false,
            addresses: '',
            url: '',
            customerData: '',
            userType: 'customer',
            deleteUrl: ADDRESS,
            confirmationModalActive: false,
            actions: [
                {
                    title: this.$t('edit'),
                    icon: 'edit',
                    type: 'edit',
                },
                {
                    title: this.$t('delete'),
                    icon: 'trash-2',
                    type: 'delete',
                }
            ],
            isDisable: null,
        }
    },

    created() {
        this.isDisable = this.props[1]
        axiosGet(CUSTOMER_ADDRESS + '/' + this.props[0]).then((response) => {
            this.addresses = response.data;
        }).catch((error) => {
            this.$toastr.e(error);
        });
    },

    methods: {
        getAddress() {
            axiosGet(CUSTOMER_ADDRESS + '/' + this.props[0]).then((response) => {
                this.addresses = response.data;
            }).catch((error) => {
                this.$toastr.e(error);
            });
        },
        titleLabel(name) {
            const map = { home: 'Home', work: 'Work', other: 'Other', na: 'NA' };
            if (!name) return 'Home';
            return map[String(name).toLowerCase()] || name;
        },
        addAddressModal() {
            this.isModalActive = true;
            this.url = '';
        },

        cancelled() {
            this.confirmationModalActive = false;
            this.deleteUrl = '';
        },
        triggerAction(row, action) {

            if (action.type === 'edit') {
                this.url = `${ADDRESS}/${row.id}`;
                this.isModalActive = true;
                this.status = row.status;
            } else if (action.type === 'delete') {
                this.confirmationModalActive = true;
                this.deleteUrl = `${ADDRESS}/${row.id}`;
            } else {
                this.getAction(row, action, active)
            }
        },
        deleteAddress() {
            axiosDelete(this.deleteUrl).then(({ data }) => {
                this.cancelled();
                this.toastAndReload(data.message, 'all-branches-table');
                this.getAddress();
            });
        },
    }
}
</script>
